import React from 'react'
import { Col } from 'react-bootstrap'
import { cerealesColor } from '../../../../config/cereales'
import { FormControlLabel, Switch } from '@material-ui/core'

function DetalleCerealAsignadoAVolcadora (props) {
  const { volcadora, setHabilitacionVolcadora = null } = props

  const updateHabilitacion = (volcadora) => {
    const habilitado = !volcadora.habilitado
    setHabilitacionVolcadora(volcadora.claveCalle, habilitado)
  }

  return (
    <>
      <div
        key={volcadora.claveVolcadora}
        className='item-cereal-asignado-volcadora'
      >
        {setHabilitacionVolcadora !== null
          ? <Col md={2}>
            {volcadora.claveVolcadora.trim() !== 'LINEAA'
              ? <FormControlLabel
                control={
                  <Switch
                    color='primary'
                    name={`${volcadora.calleDeVolcadora}-habilitado`}
                    onChange={() => { updateHabilitacion(volcadora) }}
                    checked={volcadora.habilitado}
                  />
                }
                label=''
              />
              : <></>
            }
          </Col>
          : null
        }

        <Col md={5} style={{ padding: 0 }}>
          <p style={{ margin: 0, padding: '5px' }}>
            {volcadora.claveVolcadora} <b>{volcadora.calle ? ` (${volcadora.calle})` : null}</b>
          </p>
        </Col>

        <Col md={5} style={{ padding: '2px' }}>
          {volcadora.habilitado
            ? <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <p style={{ margin: 0, padding: '0 5px' }}> {volcadora.claveCereal}</p>
              <div style={{ backgroundColor: cerealesColor[volcadora.claveCereal.trim()], height: '22px', width: '22px', borderRadius: '150px' }} />
            </div>
            : <></>
          }
        </Col>
      </div>
    </>
  )
}

export default DetalleCerealAsignadoAVolcadora
